module.exports = __webpack_public_path__ + "img/icon／1.8401e6e0.png";